export default __webpack_public_path__ + "static/media/flag-canada.00003d13.svg";